<template>
  <v-row
    class="
      justify-center
      d-flex
      mx-0
      mt-n16
      bg-white
      position-relative
      border-radius-xl
      shadow
      px-4
    "
  >
    <v-col cols="12" style="max-width: 1400px; margin: 0 auto;">
      <v-container fluid class="py-6">
        <v-row class="mt-10" v-if="userInformations">
          <v-col cols="auto">
            <v-avatar
              style="cursor: pointer"
              width="74"
              height="74"
              class="shadow border-radius-lg"
              color="bg-gradient-warning"
              @click="$router.push('/profile')"
            >
              <img
                v-if="userInformations && userInformations.avatar"
                :src="getImage(userInformations.avatar)"
                alt="Avatar"
                class="border-radius-lg"
              />
              <div
                v-else-if="
                  userInformations &&
                  userInformations.firstname &&
                  userInformations.lastname
                "
                class="text-white font-weight-bold"
                style="font-size: 24px"
              >
                {{ userInformations.firstname.charAt(0)
                }}{{ userInformations.lastname.charAt(0) }}
              </div>
              <i
                v-else
                class="material-icons-round text-white"
                style="font-size: 40px"
                >person</i
              >
            </v-avatar>
          </v-col>
          <v-col cols="auto" class="my-auto">
            <div class="h-100 pa-3">
              <h5 class="mb-1 text-h5 text-typo font-weight-bold">
                {{ userInformations && userInformations.firstname ? userInformations.firstname : '' }}
                {{ userInformations && userInformations.lastname ? userInformations.lastname : '' }}
              </h5>
              <p class="mb-0 font-weight-light text-body text-sm">
                {{ userInformations && userInformations.companyName ? userInformations.companyName : '' }}
              </p>
            </div>
          </v-col>
        </v-row>

        <!-- Header -->
        <v-row class="mt-8 mb-4">
          <v-col cols="12">
            <h3 class="text-h3 text-typo font-weight-bolder">
              Deine Tickets
            </h3>
            <p class="text-body font-weight-light text-sm mb-0" style="color: #718096">
              Übersicht über alle deine gebuchten Tickets
            </p>
          </v-col>
        </v-row>
        
        <!-- Loading State -->
        <v-row v-if="loadingEventEntries" class="mt-10">
          <v-col cols="12">
            <v-card class="card-shadow border-radius-xl py-16 text-center" style="background-color: #f7fafc;">
              <div class="mx-auto mb-6">
                <v-progress-circular
                  :size="50"
                  :width="4"
                  color="warning"
                  indeterminate
                ></v-progress-circular>
              </div>
              <h4 class="text-h4 text-typo font-weight-bolder mb-4">
                Tickets werden geladen...
              </h4>
              <p
                class="text-body font-weight-light px-6"
                style="max-width: 600px; margin: 0 auto; color: #718096"
              >
                Bitte einen Moment Geduld
              </p>
            </v-card>
          </v-col>
        </v-row>

        <!-- Empty State -->
        <v-row v-else-if="computedTickets.length === 0" class="mt-10">
          <v-col cols="12">
            <v-card class="card-shadow border-radius-xl py-16 text-center" style="background-color: #f7fafc;">
              <div class="mx-auto mb-6">
                <v-avatar
                  color="bg-gradient-warning"
                  size="100"
                  class="shadow"
                >
                  <i class="material-icons-round text-white" style="font-size: 50px;">confirmation_number</i>
                </v-avatar>
              </div>
              <h4 class="text-h4 text-typo font-weight-bolder mb-4">
                Du hast noch keine Tickets
              </h4>
              <p
                class="text-body font-weight-light mb-6 px-6"
                style="max-width: 600px; margin: 0 auto; color: #718096"
              >
                Entdecke unsere Events und buche deine ersten Tickets für
                spannende Veranstaltungen in Oelsnitz und dem Vogtland.
              </p>
              <v-btn
                :elevation="0"
                class="font-weight-bold text-xs btn-default bg-gradient-warning py-5 px-8"
                color="primary"
                to="/events"
              >
                Events entdecken
              </v-btn>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tickets Grid -->
        <v-row v-else>
          <v-col cols="12" class="position-relative">
            <v-row justify="start">
              <v-col
                v-for="item in computedTickets"
                :key="item.title"
                lg="4"
                md="4"
                sm="12"
                cols="12"
                class="pt-0 mb-0"
              >
                <ticket-card :item="item"></ticket-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
// import coreData from "@/mixins/coreDataMixin";
// import axiosAuth from "@/shared/configs/axios-auth";
import TicketCard from "@/components/Widgets/TicketCard.vue";
import moment from "moment";
export default {
  name: "Tickets",
  // mixins: [coreData],
  components: {
    TicketCard,
  },
  data: function () {
    return {};
  },
  computed: {
    userInformations() {
      return this.$store.getters.userInformations;
    },
    eventEntries() {
      return this.$store.getters.eventEntries;
    },
    loadingEventEntries() {
      return this.$store.getters.loadingEventEntries;
    },
    computedTickets() {
      var array = [];
      if (this.eventEntries) {
        this.eventEntries.forEach((element) => {
          var entryCheck = array.find(
            (entry) => entry.event._id == element.event._id
          );
          if (entryCheck) {
            entryCheck.participants.push({
              _id: element._id,
              participant_data: element.participant_data,
            });
          } else {
            var newEntry = JSON.parse(JSON.stringify(element));
            newEntry.participants.push({
              _id: element._id,
              participant_data: element.participant_data,
            });
            array.push(newEntry);
          }
        });
      }
      
      // Sort: Future events first (ascending), then past events (descending), then events without date
      const now = moment();
      const futureEvents = array.filter(item => {
        if (!item.event || !item.event.date) return false;
        return moment(item.event.date).isAfter(now, 'day') || moment(item.event.date).isSame(now, 'day');
      });
      const pastEvents = array.filter(item => {
        if (!item.event || !item.event.date) return false;
        return moment(item.event.date).isBefore(now, 'day');
      });
      const noDateEvents = array.filter(item => {
        return !item.event || !item.event.date;
      });
      
      futureEvents.sort((a, b) => {
        if (!a.event || !a.event.date || !b.event || !b.event.date) return 0;
        return moment(a.event.date).valueOf() - moment(b.event.date).valueOf();
      });
      
      pastEvents.sort((a, b) => {
        if (!a.event || !a.event.date || !b.event || !b.event.date) return 0;
        return moment(b.event.date).valueOf() - moment(a.event.date).valueOf();
      });
      
      return [...futureEvents, ...pastEvents, ...noDateEvents];
    },
  },
  mounted() {
    this.updatePageTitle();
    this.$store.dispatch("tryAutoLogin");
    this.$store.dispatch("getEventEntriesUser");
  },
  beforeDestroy() {
    this.resetPageTitle();
  },
  methods: {
    updatePageTitle() {
      // Set SEO-optimized title for tickets page
      document.title =
        "ᐅ Meine Tickets & Buchungen | Oelsnitz-Ticket.de";

      // Update meta description for better SEO
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          "ᐅ Verwalte deine gekauften Tickets und Buchungen für Events in Oelsnitz und dem Vogtland. Übersicht über alle deine Veranstaltungen!"
        );
      }
    },
    resetPageTitle() {
      // Reset page title to default when leaving the page
      document.title =
        "ᐅ Oelsnitz-Ticket.de | Deine Buchungsplattform für Veranstaltungen in Oelsnitz/Vogtl. !";

      // Reset meta description to default if available
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          "ᐅ Ihre Buchungsplattform für Veranstaltungen in Oelsnitz/Vogtl.!"
        );
      }
    },
    updateUserData() {
      this.$store.dispatch("updateUserInformations", this.userInformations);
      this.SnackbarShow(
        "Success",
        "Aktion erfolgreich!",
        "Profil gespeichert!"
      );
    },
    getImage(link) {
      return process.env.VUE_APP_API_BASEURL + "/" + link;
    },
  },
};
</script>
